// extracted by mini-css-extract-plugin
module.exports = {"kensaCoupon_Button":"KensaCoupon_kensaCoupon_Button__31_xd","kensaCoupon_Col":"KensaCoupon_kensaCoupon_Col__LEeqv","kensaCoupon_Remove":"KensaCoupon_kensaCoupon_Remove__304mq"};